var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"requiredーchip text-center px-1 ma-0",attrs:{"x-small":"","color":"#ff8f00","text-color":"white","label":""}},[_vm._v(" "+_vm._s(_vm.$t('common.input_required'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }